/**
 * APPID规则
 */
export var AppInfo = {
    "com.tencent.mtt": {
        wxAppid: "wx64f9cf5b17af074d",
        qqAppid: "100446242",
    },
    "com.tencent.reading": {
        wxAppid: "wxe90c9765ad00e2cd",
        qqAppid: "101480433",
    },
    "com.tencent.weishi": {
        wxAppid: "wx5dfbe0a95623607b",
        qqAppid: "1101083114",
    },
    // 浏览器极速版
    "sogou.mobile.explorer": {
        wxAppid: "wxe8019aad97b065f1",
        qqAppid: "1107878025",
    },
    // 小说极速版
    "com.sogou.reader.free": {
        wxAppid: "wx8d6a0ffb2a393f7b",
        qqAppid: "1106909767",
    },
};
export var AppPackage = {
    QQ: 'com.tencent.mobileqq',
    KB: 'com.tencent.reading',
    NEWS: 'com.tencent.news',
    QB: 'com.tencent.mtt',
    Qzone: 'com.qzone',
    TV: 'com.tencent.qqlive',
    WS: 'com.tencent.weishi',
    WX: 'com.tencent.mm',
    YYB: 'com.tencent.android.qqdownloader',
    QBJS: 'sogou.mobile.explorer',
    QBNOVEL: 'com.sogou.reader.free',
};
